import { render, staticRenderFns } from "./ChatHeaderBadge.vue?vue&type=template&id=011674cc&scoped=true&"
import script from "./ChatHeaderBadge.vue?vue&type=script&lang=js&"
export * from "./ChatHeaderBadge.vue?vue&type=script&lang=js&"
import style0 from "./ChatHeaderBadge.vue?vue&type=style&index=0&id=011674cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011674cc",
  null
  
)

export default component.exports